let CommentStatus = Object({
    WAITING: {value:0, label:"در انتظار تایید"},
    APPROVED: {value:1, label:"تایید شده"},
    REJECTED: {value:2, label:"رد شده"},
});

export default CommentStatus;